import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './shared/shared.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import store from './state/store';
import { EventType } from "@azure/msal-browser";
import msalInstance from './configs/auth/msalInstance';
import authService from './configs/auth/authServices';
import { LoaderProvider } from './context/loaderContext';
import { ConfigProvider } from 'antd';
import itIT from 'antd/locale/it_IT'; // Italian locale for Ant Design
import 'dayjs/locale/it'; // Italian locale for dayjs
import dayjs from 'dayjs';
import ScrollToTop from './components/common/scrollToTop';
dayjs.locale('it'); // set globally

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  // msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  authService.setActiveAccount();
}

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <Provider store={store}>
      <LoaderProvider>
        <Router>
           <ScrollToTop />
         <ConfigProvider locale={itIT}>
            <App/>
         </ConfigProvider>
        </Router>
      </LoaderProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
